import extend from 'lodash/extend';

const BiService = function (wixService) {
  const srcNum = 63,
    self = this,
    publishSiteEvId = 205;
  let brand = 'wix';
  // need to move source 63 events 421 - 433 from 'users' to 'ugc'
  const events = [
    [
      'savePublish',
      publishSiteEvId,
      [
        'wixlabs_string_1',
        'wixlabs_string_2',
        'wixlabs_bool_1',
        'wixlabs_bool_2',
        'wixlabs_bool_3',
        'wixlabs_bool_4',
        'wixlabs_bool_5',
        'wixlabs_bool_6',
        'wixlabs_num_1',
        'wixlabs_num_2',
        'wixlabs_num_3',
        'wixlabs_num_4',
        'wixlabs_bool_7',
        'wixlabs_bool_8',
        'wixlabs_bool_9',
        'event_trigger',
      ],
    ],
    ['expendLayout', 301, ['type', 'description', 'position'], 'user'],
    ['filesUploaded', 102, ['market', 'new_status', 'old_status'], 'user'],
  ];

  const appIds = wixService.getAppIds();

  self.getCompId = function () {
    return superProperties.CompId || superProperties.OrigCompId;
  };

  self.getInstanceId = function () {
    return superProperties.InstanceId;
  };

  const superProperties = {
    Uid: wixService.Utils.getUid(),
    InstanceId: wixService.Utils.getInstanceId(),
    CompId: wixService.Utils.getCompId(),
    OrigCompId: wixService.Utils.getOrigCompId(),
    IsPremium: wixService.isPremium(),
    siteId: appIds.metaSiteId,
    visitorId: wixService.Utils.getInstanceValue('aid'),
  };

  const frogSuperProperties = {
    // market          : "editor",
    // origin          : initialState.origin || "app_settings",
    // tab_name        : "",
    app_site_id: self.getInstanceId(),
    biToken: appIds.biToken || wixService.getRootFolderId(),
    instance_id: self.getCompId(),
    uuid: superProperties.Uid,
  };

  self.init = function () {
    try {
      wixService.Styles &&
        wixService.Styles.getStyleParams((styleParams) => {
          brand = styleParams.booleans.responsive ? 'editorx' : 'wix';
        });
    } catch (e) {
      console.log('calling to styleservice failed', e);
      brand = 'wix';
    }
    for (let i = 0; i < events.length; i++) {
      const event = events[i],
        eventParams = extend({ evid: event[1] }, frogSuperProperties);
      for (let j = 0; j < event[2]; j++) {
        event[2][j] = '';
      }
      self[event[0]] = eventClosure(eventParams, event[2], event[3]);
    }
  };

  self.noop = function () {};

  const report = function (params, bUserEvent /* , onSuccess, onError*/) {
    const url = bUserEvent
      ? 'https://frog.' + brand + '.com/wixlabs-ugc?'
      : 'https://frog.' + brand + '.com/wixlabs-users?';

    const cacheKiller = '_=' + new Date().getTime();

    if (params.evid === publishSiteEvId || bUserEvent) {
      if (!bUserEvent) {
        delete params.origin;
      }
      delete params.market;
    }

    if (bUserEvent) {
      delete params.app_site_id;
      delete params.tab_name;
      delete params.site_id;
      delete params.uuid;

      params.comp_id = self.getCompId();
      params.instance_id = self.getInstanceId();
      params.visitor_id = superProperties.visitorId;
    } else {
      params.is_premium = superProperties.IsPremium;
    }
    // bi.onload = onSuccess || onSuccessDef;
    // bi.onerror = onError || onErrorDef;
    const BIURL =
      url +
      cacheKiller +
      '&src=' +
      srcNum +
      '&' +
      Object.keys(params)
        .map(function (key) {
          return [
            encodeURIComponent(key),
            '=',
            encodeURIComponent(params[key]),
          ].join('');
        })
        .join('&');
    // bi.src = BIURL;
    fetch(BIURL).catch((err) => {
      console.error(err);
    });
  };

  const eventClosure = function (eventParams, paramsOrder, sUserEvent) {
    return function () {
      const bUserEvent = !!sUserEvent && sUserEvent === 'user',
        onSuccess = arguments[1] || self.noop,
        onError = arguments[2] || self.noop,
        params = arguments[0] || [];

      for (let i = 0; i < paramsOrder.length; i++) {
        eventParams[paramsOrder[i]] = params[i];
      }
      report(eventParams, bUserEvent, onSuccess, onError);
    };
  };
};

export default BiService;
